import styled from '@emotion/styled'

export const SalaryPayrollWrapper = styled.div``
